var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.69727C4.58 1.69727 1 5.27727 1 9.69727C1 13.2373 3.29 16.2273 6.47 17.2873C6.87 17.3573 7.02 17.1173 7.02 16.9073C7.02 16.7173 7.01 16.0873 7.01 15.4173C5 15.7873 4.48 14.9273 4.32 14.4773C4.23 14.2473 3.84 13.5373 3.5 13.3473C3.22 13.1973 2.82 12.8273 3.49 12.8173C4.12 12.8073 4.57 13.3973 4.72 13.6373C5.44 14.8473 6.59 14.5073 7.05 14.2973C7.12 13.7773 7.33 13.4273 7.56 13.2273C5.78 13.0273 3.92 12.3373 3.92 9.27727C3.92 8.40727 4.23 7.68727 4.74 7.12727C4.66 6.92727 4.38 6.10727 4.82 5.00727C4.82 5.00727 5.49 4.79727 7.02 5.82727C7.66 5.64727 8.34 5.55727 9.02 5.55727C9.7 5.55727 10.38 5.64727 11.02 5.82727C12.55 4.78727 13.22 5.00727 13.22 5.00727C13.66 6.10727 13.38 6.92727 13.3 7.12727C13.81 7.68727 14.12 8.39726 14.12 9.27727C14.12 12.3473 12.25 13.0273 10.47 13.2273C10.76 13.4773 11.01 13.9573 11.01 14.7073C11.01 15.7773 11 16.6373 11 16.9073C11 17.1173 11.15 17.3673 11.55 17.2873C13.1381 16.7511 14.5181 15.7304 15.4958 14.3688C16.4734 13.0073 16.9995 11.3735 17 9.69727C17 5.27727 13.42 1.69727 9 1.69727Z",
    fill: "#62718A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.b8f5901d734d313c9aa4856697c03465.svg";
export { ForwardRef as ReactComponent };